const STATES = {
  INIT: 1,
  STEP_1: 2,
  STEP_2: 3,
  STEP_3: 4,
  STEP_4: 5,
  STEP_5: 6,
  STEP_6: 7,
  STEP_7: 8,
  STEP_8: 9,
  STEP_9: 10
}

export default {
  beforeCreate () {
    this.STATES = STATES
    this._data = {
      state: STATES.INIT,
      mouse: {
        x: -9999,
        y: -9999,
        interaction: ''
      }
    }
  },
  beforeDestroy () {
    removeEventListener('scroll', this.onScroll)
    this.abort()
  },
  data () {
    return this._data
  },
  methods: {
    onScroll: function () {
      if (this._data.state === STATES.INIT) {
        this.resetInit()
      }
    },
    init: function () {
      addEventListener('scroll', this.onScroll)
      // Init
      this.resetInit()
    },
    resetInit: function () {
      clearTimeout(this._timer)
      this._timer = setTimeout(this.step1, 500)
    },
    step1: function () {
      // Step 1 Override
    },
    complete: function () {
      // Completion Override
    },
    abort: function () {
      clearTimeout(this._timer)
      this.complete()
    }
  }
}
